import { Component } from '@angular/core';

@Component({
    selector: 'home',
    template: require('./home.component.html'),
    styles: [require('./home.component.css')]
})
export class HomeComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/home/home.component.ts